import { render, staticRenderFns } from "./InvoiceOverview.vue?vue&type=template&id=4f57a7dc&"
import script from "./InvoiceOverview.vue?vue&type=script&lang=js&"
export * from "./InvoiceOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports